const fetchCounterparties = (state) => {
  state.isLoading = true
  state.error = null
  state.counterparties = []
}

const fetchCounterpartiesSuccess = (state, companies) => {
  state.isLoading = false
  state.error = null
  state.counterparties = companies
}

const fetchCounterpartiesError = (state, error) => {
  state.isLoading = false
  state.error = error
  state.counterparties = []
}

export default {
  fetchCounterparties, fetchCounterpartiesError, fetchCounterpartiesSuccess,
}
